<template>
  <div class="record-box">
    <ax-result-page v-if="isViewPermission && showResult" type="network" subtext="要不然下拉刷新试试？"></ax-result-page>
    <template v-if="recordList.length && isViewPermission">
      <ax-simple-step
        v-for="(item, index) in recordList"
        :key="index"
        :data="item"
      ></ax-simple-step>
    </template>
    <div class="no-data" v-if="isViewPermission && !showResult && !recordList.length">{{ text }}</div>
    <div class="no-data" v-if="!isViewPermission">暂无审批记录查看权限</div>
  </div>
</template>

<script>
import Vue from "vue";
import AxEhrStep from "@/components/common/AxEhrStep.vue";
import completedObj from "@/assets/js/approval/completed.js";
import upcomingObj from "@/assets/js/approval/upComDetail.js";
import request from "@/utils/request";
import CryptoJS from 'crypto-js';
Vue.component("ax-simple-step", AxEhrStep);
export default {
  name: "approve_record",
  data() {
    return {
      text: "",
      instanceId: this.$route.query.instanceId,
      recordKey: "",
      pageId: this.$route.query.pageId,
      // CurrentHrEmpId:  this.$route.query.CurrentHrEmpId,
      pageObj: null,
      isViewPermission: 1, // 0 无权限  1 有权限
      recordList: [
        // 测试数据
        // {hr_wf_action_description: '已提交', emplid_to_description: '孔维民', action_dt_ss: '799-230-23', comments: '闪电发货士大夫还是觉得烦还是觉得烦', qh_contract_yes_description: '处理以及那束带结发世纪东方火炬大厦'},
        // {hr_wf_action_description: '已审批', emplid_to_description: '孔维民', action_dt_ss: '799-230-23', comments: '闪电发货士大夫还是觉得烦还是觉得烦', qh_contract_yes_description: '处理以及那束带结发世纪东方火炬大厦'},
        // {hr_wf_action_description: '同意', emplid_to_description: '孔维民', action_dt_ss: '799-230-23', comments: '闪电发货士大夫还是觉得烦还是觉得烦', qh_contract_yes_description: '处理以及那束带结发世纪东方火炬大厦'},
        // {hr_wf_action_description: '拒绝', emplid_to_description: '孔维民', action_dt_ss: '799-230-23', comments: '闪电发货士大夫还是觉得烦还是觉得烦', qh_contract_yes_description: '处理以及那束带结发世纪东方火炬大厦'}
      ],
      showResult: false,
      toast: null
    };
  },
  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: "加载中...",
      duration: 0
    });
    this.getPageId();
    this.fetchDataByPageId();
  },
  methods: {
    // 获取pageId
    getPageId() {
      this.instanceId = this.$route.query.instanceId;
      this.pageId = this.$route.query.pageId;
      this.pageObj = completedObj[this.pageId] || upcomingObj[this.pageId];
      this.recordKey = this.pageObj.recordKey;
    },
    getRecordKey(data) {
      if (!this.recordKey) {
        for (let key in data.data) {
          if (~key.indexOf("sta")) {
            this.recordKey = key;
            break;
            return false;
          }
        }
      }
    },
    setPermission(data) {
      // 合同续签
      if (this.pageId === "renewal") {
        this.isViewPermission =
          data.data.current_oprid !== data.data.header.emplid;
      }
      // 离职
      if (this.pageId === "leaveOffice") {
        this.isViewPermission =
          data.data.current_oprid !== data.data.header.emplid;
      }
    },
    // 根绝pageId 获取数据
    fetchDataByPageId() {
      if (!this.pageObj) {
        this.showResult = true;
        return;
      }
      let options = {
        url: this.pageObj.recordUrl,
        method: this.pageObj.method
      };

      let body = {};
      this.pageObj.data.forEach(item => {
        body[item[0]] = this[item[1]];
      });
      if (this.pageObj.method === "get") {
        options.params = body;
      } else {
        options.data = body;
      }
      request(options)
        .then(({ data }) => {
          if (data.code === 200) {
            this.showResult = false;
            if (typeof data.data == 'string') {
                const d = JSON.parse(this.Decrypt(data.data))
                data.data = d
                // console.log(JSON.parse(this.Decrypt(data.data)), 111)
                // console.log(data.data,111)
              }
            this.getRecordKey(data);
            this.setPermission(data);
            if (!this.isViewPermission) return;
            this.recordList = data.data[this.recordKey];
            // 合并两个数组
            if (this.pageId == 'offer') {
              let list = data.data[this.recordKey];
              const arr = [];
              let count = 1;

              if (data.data.step_node) {
                let step_node = JSON.parse(data.data.step_node);
                let PIndex = step_node.findIndex((item) => item.status == 'P');
                if(PIndex > -1){
                  step_node = step_node.slice(0, PIndex)
                } else {
                  step_node = [];
                  return ;
                }
                //  step_node = step_node.filter((item) => item.status != 'P' || item.status != 'N');

                step_node.forEach((item) => {
                  arr.push(item.nodes[0].approver);
                });
                // console.log('step_node==', arr);
              }
              let len = list.length;
              // console.log(list[len - 1]);
              while (arr.length > 0) {
                list[list.length - count].emplid_to_description = arr.pop();
                count++;
              }
              this.recordList = list;
            }
            // 假期类审批显示待审批人
            const holidays = ['absence', 'resumption', 'newEmployeesAttendance', 'outOffice', 'cancelOutOffice', 'overtime', 'businessTrip', 'cancelBusinessTrip','statutoryOvertime']
            if (holidays.includes(this.pageId)) {
              const step_node = JSON.parse(data.data.step_node);
              step_node.forEach(item => {
                if (item.status == 'P' || item.status == 'N') {
                  let node = item.nodes[0]
                  console.log('node===', node)
                  this.recordList.push({
                    comments: "",
                    emplid_to_description: node.approver,
                    hr_wf_action_description: "待审批",
                    trans_dt: "",
                  })
                }
              })
            }
          } else {
            this.showResult = true;
          }
        })
        .catch(e => {
          this.showResult = false;
          this.text = "暂无审批记录";
        })
        .finally(_ => {
          this.text = "暂无审批记录";
          this.toast.clear();
        });
    },
    Decrypt(word) {
        //数据解密
        const key = CryptoJS.enc.Utf8.parse('A-16-Byte-keyVal');
        const iv = CryptoJS.enc.Utf8.parse('A-16-Byte-String');

        let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
        let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        let decrypt = CryptoJS.AES.decrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
      }
  },
  beforeDestroy() {
    this.toast && this.toast.clear();
  }
};
</script>
<style scoped>
.no-data {
  color: #888;
  text-align: center;
  padding: 100px 0;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
